module.exports = __webpack_public_path__ + "img/01_abe_09.cf79b368.jpg";